/*!
 * 
 *
 * 	This file is auto generated by webpack.
 * 	Do not edit this file directly.
 *
 *
 */
/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 666:
/***/ (function() {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

window.sga = window.sga || {};

window.sga.applyDiscountCodes = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(storefrontKey, newCodes) {
    var withRefresh,
        removeCode,
        cartResponse,
        cartData,
        cartLevelCodes,
        lineLevelCodes,
        allCodes,
        currentDiscountCodes,
        query,
        response,
        _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            withRefresh = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
            removeCode = _args.length > 3 && _args[3] !== undefined ? _args[3] : null;
            _context.prev = 2;
            _context.next = 5;
            return fetch('/cart.js', {});

          case 5:
            cartResponse = _context.sent;
            _context.next = 8;
            return cartResponse.json();

          case 8:
            cartData = _context.sent;
            cartLevelCodes = (cartData.cart_level_discount_applications || []).filter(function (discount) {
              return discount.type === 'discount_code';
            }).map(function (discount) {
              return discount.title;
            });
            lineLevelCodes = (cartData.items || []).flatMap(function (item) {
              return item.line_level_discount_allocations || [];
            }).filter(function (alloc) {
              return alloc.discount_application && alloc.discount_application.type === 'discount_code';
            }).map(function (alloc) {
              return alloc.discount_application.title;
            });
            allCodes = _toConsumableArray(new Set([].concat(_toConsumableArray(cartLevelCodes), _toConsumableArray(lineLevelCodes), _toConsumableArray(newCodes))));
            currentDiscountCodes = removeCode ? allCodes.filter(function (code) {
              return code !== removeCode;
            }) : allCodes;

            if (!(!currentDiscountCodes.length && !removeCode)) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return", false);

          case 15:
            query = "mutation {\n      cartDiscountCodesUpdate(\n        cartId: \"gid://shopify/Cart/".concat(cartData.token, "\"\n        discountCodes: ").concat(JSON.stringify(currentDiscountCodes), "\n      ) {\n        cart {\n          id\n          discountCodes {\n            code\n            applicable\n          }\n          checkoutUrl\n        }\n        userErrors {\n          code\n          field\n          message\n        }\n      }\n    }");
            _context.next = 18;
            return fetch("".concat(window.location.origin, "/api/2024-10/graphql.json"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': storefrontKey
              },
              body: JSON.stringify({
                query: query
              })
            });

          case 18:
            response = _context.sent;

            if (response.ok) {
              _context.next = 22;
              break;
            }

            console.error('Network response was not ok', response);
            throw new Error('Network response was not ok');

          case 22:
            if (window.cartDrawerElement && withRefresh) {
              window.cartDrawerElement.refreshCart();
            }

            return _context.abrupt("return", response);

          case 26:
            _context.prev = 26;
            _context.t0 = _context["catch"](2);
            console.log('Discounts were not applied');
            console.log(_context.t0);
            return _context.abrupt("return", false);

          case 31:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 26]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 289:
/***/ (function() {

document.addEventListener('DOMContentLoaded', function () {
  var showMoreBtn = document.querySelector('[data-collection-selector="show-more-btn"]');
  if (!showMoreBtn) return;
  var shortDescription = document.querySelector('[data-collection-selector="short-description"]');
  var longDescription = document.querySelector('[data-collection-selector="long-description"]');
  var showMoreText = showMoreBtn.querySelector('[data-collection-selector="show-more"]');
  var showLessText = showMoreBtn.querySelector('[data-collection-selector="show-less"]');
  showMoreBtn.addEventListener('click', function () {
    if (shortDescription.classList.contains('hidden')) {
      shortDescription.classList.remove('hidden');
      longDescription.classList.add('hidden');
      showMoreText.classList.remove('hidden');
      showLessText.classList.add('hidden');
      scrollToTop();
    } else {
      shortDescription.classList.add('hidden');
      longDescription.classList.remove('hidden');
      showMoreText.classList.add('hidden');
      showLessText.classList.remove('hidden');
    }
  });

  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
});

/***/ }),

/***/ 220:
/***/ (function() {

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

window.sga = window.sga || {};
window.sga.filterCombinedListing = {
  filterResults: function filterResults() {
    var results = document.getElementById('filter-results');

    if (!results) {
      return;
    }

    var _iterator = _createForOfIteratorHelper(results.querySelectorAll('[data-id="product-card-variants"]')),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var productVariants = _step.value;

        try {
          var jsonData = productVariants.textContent;
          var parsedData = JSON.parse(jsonData);

          var _this$getFiltersFromU = this.getFiltersFromURL(),
              optionFilters = _this$getFiltersFromU.optionFilters,
              metafieldFilters = _this$getFiltersFromU.metafieldFilters;

          var matchingVariants = this.findMatchingVariants(parsedData.variants, optionFilters);

          if (matchingVariants.length > 1) {
            matchingVariantsByMetafield = this.filterByMetafields(matchingVariants, parsedData.variant_metafields, metafieldFilters);

            if (matchingVariantsByMetafield.length) {
              matchingVariants = matchingVariantsByMetafield;
            }
          }

          var bestMatch = matchingVariants[0] || null;
          var productCard = productVariants.closest('product-card');
          this.changeProductCard(productCard, bestMatch, parsedData);
        } catch (error) {
          console.error("Error parsing JSON:", error);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  getFiltersFromURL: function getFiltersFromURL() {
    var urlParams = new URL(location.href).searchParams;
    var optionFilters = {};
    var metafieldFilters = {};

    var _iterator2 = _createForOfIteratorHelper(urlParams.entries()),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _step2$value = _slicedToArray(_step2.value, 2),
            key = _step2$value[0],
            value = _step2$value[1];

        if (key.startsWith('filter.v.option.')) {
          var optionKey = key.split('.').pop();

          if (!optionFilters[optionKey]) {
            optionFilters[optionKey] = [];
          }

          optionFilters[optionKey].push(decodeURIComponent(value));
        } else if (key.startsWith('filter.p.m.') || key.startsWith('filter.v.m.')) {
          var metafieldKey = key.split('.').slice(2).join('.');

          if (!metafieldFilters[metafieldKey]) {
            metafieldFilters[metafieldKey] = [];
          }

          metafieldFilters[metafieldKey].push(decodeURIComponent(value));
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return {
      optionFilters: optionFilters,
      metafieldFilters: metafieldFilters
    };
  },
  findMatchingVariants: function findMatchingVariants(variants, filters) {
    return variants.filter(function (variant) {
      return Object.entries(filters).every(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            filterKey = _ref2[0],
            filterValues = _ref2[1];

        var variantOptions = Object.keys(variant).filter(function (key) {
          return key.startsWith('option');
        }).map(function (key) {
          return variant[key];
        });
        return filterValues.some(function (value) {
          return variantOptions.includes(value);
        });
      });
    });
  },
  filterByMetafields: function filterByMetafields(variants, metafieldsData, filters) {
    return variants.filter(function (variant) {
      var metafields = metafieldsData[variant.id] || [];
      return Object.entries(filters).every(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            filterKey = _ref4[0],
            filterValues = _ref4[1];

        var metafield = metafields.find(function (m) {
          return m.metafield === filterKey.replace(/^m\./, "");
        });

        if (!metafield) {
          return true;
        }

        return filterValues.some(function (value) {
          return Array.isArray(metafield.value) && metafield.value.includes(value);
        });
      });
    });
  },
  changeProductCard: function changeProductCard(product, variant, data) {
    if (!product) {
      return;
    }

    var productImageElement = product.querySelector('[data-id="product-card-image"]');
    var image = data.defaultImage;

    if (variant) {
      image = data.variantsImages[variant.id];
    }

    if (productImageElement) {
      productImageElement.innerHTML = image;
    }
  }
};

/***/ }),

/***/ 738:
/***/ (function() {

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

window.sga = window.sga || {};
window.sga.formFunctions = {
  isFileError: function isFileError(responseData) {
    if (!(responseData !== null && responseData !== void 0 && responseData.fileUploadResults)) {
      return false;
    }

    for (var _i = 0, _Object$entries = Object.entries(responseData.fileUploadResults); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      if (typeof value === 'string' && value.includes('error')) {
        return true;
      }
    }
  },
  removeFormError: function removeFormError(form) {
    var errorElement = form.querySelector('[data-js-error]');

    if (!errorElement) {
      return;
    }

    errorElement.remove();
  },
  showFormError: function showFormError(form, error) {
    var _document$querySelect;

    var success = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    window.sga.loading.hide();
    this.removeFormError(form);
    var isSuccess = success || error === window.sga.registrationErrors.customer_registered;
    var bgColor = isSuccess ? 'bg-success-bg' : 'bg-error-bg';
    var textColor = isSuccess ? 'text-success-text' : 'text-error-text';
    var html = "\n\t\t\t<div data-js-error class=\"alert mb-8 ".concat(bgColor, " ").concat(textColor, "\" tabindex=\"-1\" autofocus>\n\t\t\t\t").concat(!isSuccess ? "<h2 class=\"h5 text-current\">".concat(window.sga.registrationErrors["error_heading"], "</h2>") : '', "\n\t\t\t\t<ul class=\"styled-list\">\n\t\t\t\t\t<li>").concat(error, "</li>\n\t\t\t\t</ul>\n\t\t\t</div>");

    if (!form) {
      return;
    }

    form.insertAdjacentHTML('afterbegin', html);
    var errorElement = form.querySelector('[data-js-error]');

    if (!errorElement) {
      return;
    }

    var rect = errorElement.getBoundingClientRect();
    var offset = ((_document$querySelect = document.querySelector('store-header')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.clientHeight) || 0;
    window.scrollTo({
      top: rect.top + window.pageYOffset - offset,
      behavior: 'smooth'
    });
  },
  getBEHeaders: function getBEHeaders(name, customerID) {
    return {
      'x-shopify-hmac-sha256': window.sga.headersForBE[name + 'Hmac'],
      'x-shopify-customer-id': customerID,
      'x-triggered-at': window.sga.headersForBE[name + 'Timestamp']
    };
  },
  initFileFieldListeners: function initFileFieldListeners(form) {
    var fileInputs = form.querySelectorAll('.file__field input[type="file"]');
    fileInputs.forEach(function (fileInput) {
      var parentField = fileInput.closest('.file__field');
      if (!parentField) return;
      var fileList = parentField.querySelector('.file-list');

      if (!fileList) {
        fileList = document.createElement('div');
        fileList.classList.add('file-list');
        parentField.appendChild(fileList);
      }

      fileInput._allFiles = [];

      var updateFileDisplay = function updateFileDisplay() {
        fileList.innerHTML = '';

        fileInput._allFiles.forEach(function (file, index) {
          var fileItem = document.createElement('div');
          fileItem.classList.add('file-item');
          var fileLink = document.createElement('a');
          fileLink.href = URL.createObjectURL(file);
          fileLink.target = '_blank';
          fileLink.textContent = file.name;
          var removeButton = document.createElement('button');
          removeButton.innerHTML = window.sga.removeIcon;
          removeButton.classList.add('remove-file');
          removeButton.addEventListener('click', function () {
            fileInput._allFiles.splice(index, 1);

            var dt = new DataTransfer();

            fileInput._allFiles.forEach(function (f) {
              return dt.items.add(f);
            });

            fileInput.files = dt.files;
            updateFileDisplay();

            if (!fileInput.files.length) {
              parentField.classList.remove('file__field-filled');
            }
          });
          fileItem.appendChild(fileLink);
          fileItem.appendChild(removeButton);
          fileList.appendChild(fileItem);
        });
      };

      fileInput.addEventListener('change', function () {
        if (fileInput.files && fileInput.files.length > 0) {
          parentField.classList.add('file__field-filled');
          Array.from(fileInput.files).forEach(function (file) {
            var exists = fileInput._allFiles.some(function (f) {
              return f.name === file.name && f.size === file.size;
            });

            if (!exists) {
              fileInput._allFiles.push(file);
            }
          });
          var dt = new DataTransfer();

          fileInput._allFiles.forEach(function (f) {
            return dt.items.add(f);
          });

          fileInput.files = dt.files;
          updateFileDisplay();
        }
      });
    });
  }
};

/***/ }),

/***/ 121:
/***/ (function() {

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

window.sga = window.sga || {};
window.sga.formValidation = {
  validateField: function validateField(fieldName, value, rules) {
    var _iterator = _createForOfIteratorHelper(rules),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var rule = _step.value;
        var errorMessage = rule.validate(value, fieldName, rule.message);
        if (errorMessage) return errorMessage;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return null;
  },
  required: function required(value, fieldName, message) {
    return value && value.trim() ? null : "".concat(fieldName, " - ").concat(message);
  }
};

/***/ }),

/***/ 893:
/***/ (function() {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var originalFetch = window.fetch;

window.fetch = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(resource, init) {
    var response, url, cartUrlsToCheck, isCartChange, isLogin, cartResponse, cartData;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return originalFetch(resource, init);

          case 2:
            response = _context.sent;
            url = new URL(resource, window.location.href);
            cartUrlsToCheck = ['/cart/add', '/cart/add.js', '/cart/change', '/cart/change.js', '/cart/update', '/cart/update.js'];
            isCartChange = cartUrlsToCheck.some(function (path) {
              return url.pathname.includes(path);
            });
            isLogin = url.pathname.includes('apps/authapp/user');

            if (!(isLogin && response.status === 200)) {
              _context.next = 10;
              break;
            }

            window.gtm.pushToDataLayer({
              'event': 'ec.message',
              'eventParameters': {
                'type': 'sing_in'
              },
              '_clear': true
            }, window.gtm.analytics.gtm_dev_mode);
            return _context.abrupt("return");

          case 10:
            if (isCartChange) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", response);

          case 12:
            _context.prev = 12;
            _context.next = 15;
            return fetch("".concat(theme.routes.cart, "?view=gtm-items"));

          case 15:
            cartResponse = _context.sent;
            _context.next = 18;
            return cartResponse.json();

          case 18:
            cartData = _context.sent;

            if (cartData) {
              localStorage.setItem("cart_analytics", JSON.stringify(cartData));
            }

            _context.next = 25;
            break;

          case 22:
            _context.prev = 22;
            _context.t0 = _context["catch"](12);
            console.log(_context.t0);

          case 25:
            _context.prev = 25;
            return _context.abrupt("return", response);

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[12, 22, 25, 28]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

window.gtm = window.gtm || {};
window.gtm.getCartData = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
  var cartResponse, cartData;
  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return fetch("".concat(theme.routes.cart, "?view=gtm-items"));

        case 3:
          cartResponse = _context2.sent;
          _context2.next = 6;
          return cartResponse.json();

        case 6:
          cartData = _context2.sent;
          return _context2.abrupt("return", cartData);

        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](0);
          console.log(_context2.t0);
          return _context2.abrupt("return", []);

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[0, 10]]);
}));

window.gtm.addToCart = function () {
  var _ref3 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee3(variantId) {
    var _window$gtm$analytics;

    var cartData, cartItem;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return window.gtm.getCartData();

          case 2:
            cartData = _context3.sent;
            cartItem = cartData.find(function (item) {
              return item.id === variantId;
            });

            if (cartItem) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt("return");

          case 6:
            window.gtm.pushToDataLayer({
              'event': 'ec.add_to_cart',
              'send_to': (_window$gtm$analytics = window.gtm.analytics) === null || _window$gtm$analytics === void 0 ? void 0 : _window$gtm$analytics.gtm_id,
              'user': window.gtm.customerData,
              'language': window.gtm.data.language,
              'currencyCode': window.gtm.data.currency,
              'consent': {
                'analytics': window.gtm.customerData.analytics,
                'marketing': window.gtm.customerData.accepts_marketing
              },
              'fired_from': window.gtm.data.fired_from,
              '_clear': true,
              'ecommerce': {
                'currencyCode': window.gtm.data.currency,
                'valueWithoutVat': cartItem.priceWithoutVat,
                'valueWithVat': cartItem.priceWithVat,
                'products': [cartItem]
              }
            }, window.gtm.analytics.gtm_dev_mode);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x3) {
    return _ref3.apply(this, arguments);
  };
}();

window.gtm.removeFromCart = function () {
  var _ref4 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee4(variantId, quantity) {
    var _window$gtm$analytics2;

    var cartData, cartItem;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return window.gtm.getCartData();

          case 2:
            cartData = _context4.sent;
            cartItem = cartData.find(function (item) {
              return item.id === variantId;
            });

            if (cartItem) {
              _context4.next = 6;
              break;
            }

            return _context4.abrupt("return");

          case 6:
            cartItem.quantity = quantity;
            window.gtm.pushToDataLayer({
              'event': 'ec.remove_from_cart',
              'send_to': (_window$gtm$analytics2 = window.gtm.analytics) === null || _window$gtm$analytics2 === void 0 ? void 0 : _window$gtm$analytics2.gtm_id,
              'user': window.gtm.customerData,
              'language': window.gtm.data.language,
              'currencyCode': window.gtm.data.currency,
              'consent': {
                'analytics': window.gtm.customerData.analytics,
                'marketing': window.gtm.customerData.accepts_marketing
              },
              'fired_from': window.gtm.data.fired_from,
              '_clear': true,
              'ecommerce': {
                'currencyCode': window.gtm.data.currency,
                'valueWithoutVat': cartItem.priceWithoutVat,
                'valueWithVat': cartItem.priceWithVat,
                'products': [cartItem]
              }
            }, window.gtm.analytics.gtm_dev_mode);

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

/***/ }),

/***/ 832:
/***/ (function() {

window.sga = window.sga || {};
window.sga.loading = {
  show: function show() {
    var loader = document.querySelector('[data-id="yoggies-loading-wheel"]');

    if (loader) {
      loader.classList.add('--active');
    }
  },
  hide: function hide() {
    var loader = document.querySelector('[data-id="yoggies-loading-wheel"]');

    if (loader) {
      loader.classList.remove('--active');
    }
  }
};

/***/ }),

/***/ 288:
/***/ (function() {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var handleClick = function handleClick(event) {
  var boxInfoShowMore = event.currentTarget;
  var containerElement = boxInfoShowMore.closest('[data-box-info]');
  var textWrapperElement = containerElement === null || containerElement === void 0 ? void 0 : containerElement.querySelector('[data-box-info-text-wrapper]');
  var textInnerElement = boxInfoShowMore.querySelector('[data-box-info-read-more-text]');
  if (!textInnerElement || !containerElement || !textWrapperElement) return;
  var textWrapperHeight = "".concat(containerElement.dataset.textWrapperHeight, "px");
  var textHeight = "".concat(containerElement.dataset.textHeight, "px");
  var textOldValue = textInnerElement.innerText;
  var textNewValue = textInnerElement.dataset.boxInfoReadMoreText;
  textWrapperElement.style.maxHeight = containerElement.classList.contains('open') ? textWrapperHeight : textHeight;
  containerElement.classList.toggle('open');
  textInnerElement.innerHTML = textNewValue;
  textInnerElement.dataset.boxInfoReadMoreText = textOldValue;
};

var toggleContent = function toggleContent() {
  var boxInfoShowMore = document.querySelector('[data-box-info-read-more]');
  var containerElement = boxInfoShowMore === null || boxInfoShowMore === void 0 ? void 0 : boxInfoShowMore.closest('[data-box-info]');
  var textElement = containerElement === null || containerElement === void 0 ? void 0 : containerElement.querySelector('[data-box-info-text]');

  if (!boxInfoShowMore || !containerElement || !textElement) {
    return;
  }

  var textWrapperHeight = containerElement.dataset.textWrapperHeight;
  var textHeight = textElement.offsetHeight;
  containerElement.dataset.textHeight = textElement.offsetHeight;

  if (textWrapperHeight < textHeight) {
    boxInfoShowMore.style.display = 'inline-flex';
    boxInfoShowMore.removeEventListener('click', handleClick);
    boxInfoShowMore.addEventListener('click', handleClick);
  } else {
    boxInfoShowMore.style.display = 'none';
  }
};

var insertLoyaltyPointsName = function insertLoyaltyPointsName() {
  var nameElement = document.querySelector('[data-loyalty-points-name]');
  var loyaltyPointsElement = document.querySelector('.ll__points-earned');

  if (!nameElement || !loyaltyPointsElement) {
    console.warn('Loyalty points name or loyalty points element not found');
    return;
  }

  var loyaltyPointsEarned = parseInt(loyaltyPointsElement.innerText);
  nameElement.innerText = loyaltyPointsEarned === 1 ? theme.strings.loyaltyPointsName.singular : loyaltyPointsEarned >= 5 ? theme.strings.loyaltyPointsName.genitivePlural : theme.strings.loyaltyPointsName.dualPlural;
};

var refreshProductDetail = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(variantId) {
    var productDetailSection, productDetailsSectionId, url, response, data, parser, doc, newProductDetailSection;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            productDetailSection = document.querySelector('#product-details');

            if (productDetailSection) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return");

          case 4:
            productDetailsSectionId = productDetailSection.dataset.sectionRefreshId;
            url = "".concat(window.location.href, "/?variant=").concat(variantId, "&section_id=").concat(productDetailsSectionId);
            _context.next = 8;
            return fetch(url, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            });

          case 8:
            response = _context.sent;

            if (response.ok) {
              _context.next = 11;
              break;
            }

            throw new Error('Network response was not ok');

          case 11:
            _context.next = 13;
            return response.text();

          case 13:
            data = _context.sent;
            parser = new DOMParser();
            doc = parser.parseFromString(data, 'text/html');
            newProductDetailSection = doc.querySelector('#product-details');

            if (newProductDetailSection) {
              _context.next = 19;
              break;
            }

            throw new Error('Product detail section not found in the response');

          case 19:
            productDetailSection.innerHTML = newProductDetailSection.innerHTML;
            _context.next = 25;
            break;

          case 22:
            _context.prev = 22;
            _context.t0 = _context["catch"](0);
            console.error("Error in on:variant:change event:", _context.t0);

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 22]]);
  }));

  return function refreshProductDetail(_x) {
    return _ref.apply(this, arguments);
  };
}();

document.addEventListener('DOMContentLoaded', function () {
  toggleContent();
  insertLoyaltyPointsName();
});
window.addEventListener('resize', toggleContent);
document.addEventListener('on:variant:change', function (e) {
  console.log(e.detail);
  refreshProductDetail(e.detail.variant.id);
});

/***/ }),

/***/ 818:
/***/ (function() {

(function () {
  function init() {
    var popup = document.getElementById('site-popup');
    if (!popup) return;
    var STORAGE_KEY = 'yoggies_popup_closed';
    var isDesignMode = popup.dataset.designMode === 'true';

    function safeStorageGet(key) {
      try {
        return window.sessionStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }

    function safeStorageSet(key, value) {
      try {
        window.sessionStorage.setItem(key, value);
      } catch (e) {}
    }

    if (!isDesignMode && safeStorageGet(STORAGE_KEY)) return;
    var closeBtn = document.getElementById('site-popup-close');
    if (!closeBtn) return;

    function handleKeydown(e) {
      if (e.key === 'Escape') close();
    }

    function show() {
      popup.removeAttribute('aria-hidden');
      popup.classList.add('popup-notification--visible');
      document.addEventListener('keydown', handleKeydown);
    }

    function close() {
      popup.classList.remove('popup-notification--visible');
      popup.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', handleKeydown);
      safeStorageSet(STORAGE_KEY, '1');
    }

    closeBtn.addEventListener('click', close);
    var trigger = popup.dataset.popupTrigger || 'immediate';
    var delay = parseInt(popup.dataset.popupDelay, 10) || 0;
    var scrollPct = parseInt(popup.dataset.popupScrollPct, 10) || 0;

    if (trigger === 'delay') {
      setTimeout(show, delay * 1000);
    } else if (trigger === 'scroll') {
      var scrollHandler = function scrollHandler() {
        if (!document.body.contains(popup)) {
          window.removeEventListener('scroll', scrollHandler);
          return;
        }

        var scrollable = document.documentElement.scrollHeight - window.innerHeight;

        if (scrollable <= 0) {
          show();
          window.removeEventListener('scroll', scrollHandler);
          return;
        }

        var scrolled = window.scrollY / scrollable * 100;

        if (scrolled >= scrollPct) {
          show();
          window.removeEventListener('scroll', scrollHandler);
        }
      };

      window.addEventListener('scroll', scrollHandler, {
        passive: true
      });
    } else {
      show();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/***/ }),

/***/ 62:
/***/ (function() {

window.sga = window.sga || {};
window.sga.utils = {
  removeDiacritics: function removeDiacritics(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  },
  showAddToCartNotification: function showAddToCartNotification(notificationElement) {
    if (notificationElement) {
      setTimeout(function () {
        notificationElement.hidden = false;
      }, 300);
      setTimeout(function () {
        notificationElement.hidden = true;
      }, notificationElement.dataset.visibleFor || 3000);
    }
  }
};

/***/ }),

/***/ 973:
/***/ (function() {

document.addEventListener('DOMContentLoaded', function () {
  var breedTable = document.querySelector('[data-breed-table-selector="section"]');
  var breedTableControlsSet = breedTable === null || breedTable === void 0 ? void 0 : breedTable.querySelector('[data-breed-table-selector="controls"]');
  if (!breedTable || !breedTableControlsSet) return;
  var breedTableControlBtns = breedTableControlsSet.querySelectorAll('button');
  var varieties = breedTable.querySelectorAll('[data-breed-table-selector="variety"]');
  var previousActiveBtn = breedTableControlsSet.querySelector('button.--active');
  breedTableControlBtns.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();

      if (previousActiveBtn) {
        previousActiveBtn.classList.remove('--active');
      }

      button.classList.add('--active');
      var selectedVariety = button.id;
      varieties.forEach(function (variety) {
        variety.classList.remove('--active');

        if (variety.id === selectedVariety) {
          variety.classList.add('--active');
        }
      });
      previousActiveBtn = button;
    });
  });
});

/***/ }),

/***/ 120:
/***/ (function() {

document.addEventListener('DOMContentLoaded', function () {
  var buttonsElement = '.js-not-implemented-yet';
  document.querySelectorAll(buttonsElement).forEach(function (button) {
    button.addEventListener('mouseenter', function (e) {
      var tooltipExist = e.target.querySelector('.tooltip');

      if (!tooltipExist) {
        e.target.style.position = 'relative';
        e.target.insertAdjacentHTML('beforeend', "<div class=\"tooltip\">Not implemented yet</div>");
      }
    });
    button.addEventListener('mouseleave', function (e) {
      var tooltip = e.target.querySelector('.tooltip');

      if (tooltip) {
        e.target.style.removeProperty('position');
        tooltip.remove();
      }
    });
  });
});

/***/ }),

/***/ 119:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
class ShopifyFrontendHelper {
    constructor() {
        this.routes = '/';
        if (window.hasOwnProperty('Shopify')) {
            this.routes = window.Shopify.routes.root;
        }
    }
    fetchConfig(type = 'json') {
        return {
            method: 'POST',
            headers: { 'Content-Type': `application/${type}`, 'Accept': `application/${type}` }
        };
    }
    /* Will add items array to cart */
    async addToCart(items) {
        const body = JSON.stringify({ items: items });
        const config = this.fetchConfig();
        return await fetch(this.routes + 'cart/add.js', Object.assign(Object.assign({}, config), { body }))
            .then((response) => { return response.json(); })
            .then((state) => { return state; })
            .catch((e) => {
            return e;
        });
    }
    /* Will add variant of product to cart */
    async addVariantToCart(variantId, quantity, sellingPlan = null) {
        const items = [
            {
                id: variantId,
                quantity: quantity
            }
        ];
        if (sellingPlan) {
            items[0]["selling_plan"] = sellingPlan;
        }
        const body = JSON.stringify({ items: items });
        const config = this.fetchConfig();
        return await fetch(this.routes + 'cart/add.js', Object.assign(Object.assign({}, config), { body }))
            .then((response) => { return response.json(); })
            .then((state) => { return state; })
            .catch((e) => {
            return e;
        });
    }
    /* Will remove variant from cart */
    async removeFromCart(variantId) {
        let updates = {};
        updates[variantId] = 0;
        const body = JSON.stringify({ updates: updates });
        const config = this.fetchConfig();
        return await fetch(this.routes + 'cart/update.js', Object.assign(Object.assign({}, config), { body }))
            .then((response) => { return response.json(); })
            .then((state) => { return state; })
            .catch((e) => {
            return e;
        });
    }
    /* Will change quantity of variant in cart */
    async updateQuantityInCart(variantId, quantity, itemKey = null, updateSellingPlan = false, sellingPlan = null) {
        const updateBody = {
            id: itemKey ? itemKey : variantId,
            quantity: quantity,
        };
        if (updateSellingPlan) {
            updateBody["selling_plan"] = sellingPlan;
        }
        const body = JSON.stringify(updateBody);
        const config = this.fetchConfig();
        return await fetch(this.routes + 'cart/change.js', Object.assign(Object.assign({}, config), { body }))
            .then((response) => { return response.json(); })
            .then((state) => { return state; })
            .catch((e) => {
            return e;
        });
    }
    /* Will change quantity of variant in cart */
    async updateCartItem(updatedItem) {
        const body = JSON.stringify(updatedItem);
        const config = this.fetchConfig();
        return await fetch(this.routes + 'cart/change.js', Object.assign(Object.assign({}, config), { body }))
            .then((response) => { return response.json(); })
            .then((state) => { return state; })
            .catch((e) => {
            return e;
        });
    }
    /*
    Search function
    Type: product, page, article, collection
    Unavailable products:
        show: Show unavailable products.
        hide: Hide unavailable products.
        last: Show unavailable products below other matching results.
    Fields: author, body, product_type, tag, title, variants.barcode, variants.sku, variants.title, vendor
    More about parameters: https://shopify.dev/api/ajax/reference/predictive-search
    */
    async search(query, type = 'product', limit = 10, unavailable_products = 'last', fields = 'title,product_type,variants.title,vendor') {
        const url = this.routes
            + 'search/suggest.json?q='
            + query
            + '&resources[type]=' + type
            + '&resources[limit]=' + limit
            + '&resources[options][unavailable_products]=' + unavailable_products
            + '&resources[options][fields]=' + fields;
        return await fetch(url)
            .then((response) => response.json())
            .then((suggestions) => {
            return suggestions.resources.results;
        })
            .catch((e) => {
            return e;
        });
    }
    /* Will clear cart items */
    async clearCartItems() {
        const config = this.fetchConfig();
        return await fetch(this.routes + 'cart/clear.js', Object.assign({}, config))
            .then((response) => { return response.json(); })
            .then((state) => { return state; })
            .catch((e) => {
            return e;
        });
    }
    /* Will clear cart items with attributes and properties */
    async clearCartFully() {
        /* First clear attributes and note in cart */
        await fetch('/cart.js').then(result => result.json()).then(async (cart) => {
            for (const attr in cart.attributes) {
                cart.attributes[attr] = null;
            }
            cart.note = '';
            const body = JSON.stringify(cart);
            const config = this.fetchConfig();
            await fetch(this.routes + 'cart/update.js', Object.assign(Object.assign({}, config), { body }))
                .then((response) => { return response.json(); })
                .then((state) => { return state; })
                .catch((e) => {
                return e;
            });
        });
        /* Clear cart  items */
        return await this.clearCartItems();
    }
    /* Will log in customer. Recaptcha has to be disabled. If redirectUrl is empty we don't redirect after login */
    async customerLogin(email, password, redirectUrl = '/account/') {
        let formData = new FormData();
        formData.append('customer[email]', email);
        formData.append('customer[password]', password);
        formData.append('form_type', 'customer_login');
        formData.append('utf8', '✓');
        return await fetch("/account/login", {
            method: "POST",
            mode: "no-cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Content-Type": "form-data"
            },
            body: formData
        })
            .then((response) => { return response.text(); })
            .then((html) => {
            if (!html.includes('/account/logout')) {
                return 'Wrong email or password';
            }
            else {
                if (redirectUrl != '') {
                    location.href = redirectUrl;
                }
                return 'Logged In';
            }
        })
            .catch((e) => {
            return e;
        });
    }
    /* Will log out customer */
    async customerLogout(redirectUrl = '/') {
        return await fetch(this.routes + 'account/logout')
            .then((response) => { })
            .then((state) => {
            if (redirectUrl != '') {
                location.href = redirectUrl;
            }
            return 'Logged Out';
        })
            .catch((e) => {
            return e;
        });
        ;
    }
}
exports.Z = ShopifyFrontendHelper;


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";

// EXTERNAL MODULE: ./node_modules/shopify-api-js/lib/ShopifyFrontendHelper.js
var ShopifyFrontendHelper = __webpack_require__(119);
;// CONCATENATED MODULE: ./js/libs.js

window.shopifyFrontendHelper = new ShopifyFrontendHelper/* default */.Z();
// EXTERNAL MODULE: ./js/partials/loading.js
var loading = __webpack_require__(832);
// EXTERNAL MODULE: ./js/partials/form.js
var partials_form = __webpack_require__(738);
// EXTERNAL MODULE: ./js/partials/filtering.js
var filtering = __webpack_require__(220);
// EXTERNAL MODULE: ./js/sections/breed-table.js
var breed_table = __webpack_require__(973);
// EXTERNAL MODULE: ./js/partials/utils.js
var utils = __webpack_require__(62);
// EXTERNAL MODULE: ./js/partials/gtm.js
var gtm = __webpack_require__(893);
// EXTERNAL MODULE: ./js/partials/formValidation.js
var formValidation = __webpack_require__(121);
// EXTERNAL MODULE: ./js/partials/main-product.js
var main_product = __webpack_require__(288);
// EXTERNAL MODULE: ./js/partials/collection-description.js
var collection_description = __webpack_require__(289);
// EXTERNAL MODULE: ./js/partials/cartDiscounts.js
var cartDiscounts = __webpack_require__(666);
// EXTERNAL MODULE: ./js/partials/popup-notification.js
var popup_notification = __webpack_require__(818);
// EXTERNAL MODULE: ./js/utils/notImplementedYet.js
var notImplementedYet = __webpack_require__(120);
;// CONCATENATED MODULE: ./js/theme.js














}();
/******/ })()
;